<template>
    <Form :colon="false" :ref="e => (refs.form = e)" layout="horizontal">
        <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm" :fields="data.fields" :skeleton="isLoading"></TemplateBuilder>
    </Form>

    <div>
        <Row type="flex" justify="center" align="middle" class="min-h-10vh mb-3">
            <CIcon file="information.svg" style="font-size: 50px; color: #0dcaf0"></CIcon>
        </Row>
        <Row>
            <Col :xs="24">
                <div class="text-center" v-if="['draft', 'waitModify'].includes(props.form?.useForm?.modelRef?.refStatus?.key) || props.form?.useForm?.modelRef?.isCancelRequest">
                    {{  props.modalMessage ? props.modalMessage : $t("views.request.licenseRequest.modal.confirmSendRequest", { code: props.form?.useForm?.modelRef?.refVesselRequest?.code, licenseNumber: props.form?.useForm?.modelRef?.refVesselRequest?.licenseNumber })}}
                </div>
                <div class="text-center" v-else>
                    {{  props.modalMessage ? props.modalMessage : $t("views.request.licenseRequest.modal.confirmText", { code: props.form?.useForm?.modelRef?.refVesselRequest?.code, licenseNumber: props.form?.useForm?.modelRef?.refVesselRequest?.licenseNumber })}}
                </div>
            </Col>
            <Col :xs="24">
                <div class="text-center">
                    {{
                        $t("views.request.licenseRequest.modal.confirmDetailText", {
                            refLicenseTypeValue: props.form?.useForm?.modelRef?.refRequestType?.value,
                            code: props.form?.useForm?.modelRef?.refVesselRequest?.code,
                            name: props.form?.useForm?.modelRef?.refVesselRequest?.name
                        })
                    }}
                </div>
            </Col>
        </Row>
    </div>
</template>

<script>
import { Col, Form, Row } from "ant-design-vue";
import { defineAsyncComponent, defineComponent, reactive  } from "vue";
import { initForm, isLoading, onClickModalOk } from "./confirm-request.logic";

export default defineComponent({
    components: {
        Form,
        Row,
        Col,
        TemplateBuilder: defineAsyncComponent(() => import("../../../../components/input/template-builder/TemplateBuilder")),
        CIcon: defineAsyncComponent(() => import("../../../../components/icon/CIcon"))
    },
    props: {
        viewOnly: { default: false },
        form: {},
        ignoreValidate:  { default: false },
        modalMessage: { default: null }
    },
    setup(props) {
        const data = reactive({ rowProp: { gutter: 24 } });
        const refs = reactive({ form: null });
        initForm({ props, data, refs });
        const callOnClickModalOk = () => onClickModalOk({ data, refs });
        return {
            props,
            data,
            refs,
            isLoading,
            callOnClickModalOk,
        };
    }
});
</script>
